import React from 'react';

const Metronome = ({ className = '', title = '' }) => {
  return (
    <svg className={className} width="27" height="42" viewBox="0 0 27 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title lang="en">{title}</title>
      <path d="M3.20819 29.8333L13.2143 2.87389L23.2204 29.8333H3.20819Z" stroke="#FCEE21" strokeWidth="2"/>
      <path d="M0.978882 1.9577L13.459 23.9815" stroke="#FCEE21" strokeWidth="2"/>
      <circle cx="3.91531" cy="6.85183" r="3.42593" fill="#FCEE21"/>
    </svg>
  )
};

export default Metronome;
